import { Add, Delete } from "@mui/icons-material";
import {
  Box,
  IconButton,
  Paper,
  TextField,
  Tooltip,
} from "@mui/material";
import { Field, Section } from "model/robot";
import FieldEditor from "./FieldEditor";
import { useTranslations } from "hooks";
import { getTranslation } from "common";

interface SectionEditorProps {
  sectionIndex: number;
  section: Section;
  isOnlySection: boolean;
  updateSectionName: (sectionIndex: number, name: string) => void;
  removeSection: (sectionIndex: number) => void;
  addField: (sectionIndex: number) => void;
  updateField: (
    sectionIndex: number,
    fieldIndex: number,
    changes: Partial<Field>
  ) => void;
  removeField: (sectionIndex: number, fieldIndex: number) => void;
}

export default function SectionEditor({
  sectionIndex,
  section,
  isOnlySection,
  updateSectionName,
  removeSection,
  addField,
  updateField,
  removeField,
}: SectionEditorProps) {
  const translate = useTranslations()
  return (
    <Paper
      elevation={2}
      sx={{ p: 2, mb: 3, border: "1px solid #eee", width: 600, marginLeft: "auto", marginRight: "auto", borderRadius: 2 }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <TextField
          label={getTranslation(translate, "generic.section_name")}
          value={section.name}
          onChange={(e) => updateSectionName(sectionIndex, e.target.value)}
          variant="standard"
          sx={{ flexGrow: 1 }}
        />
        <Tooltip title={getTranslation(translate, "generic.remove_section")}>
          <IconButton
            color="error"
            onClick={() => removeSection(sectionIndex)}
            disabled={isOnlySection}
          >
            <Delete />
          </IconButton>
        </Tooltip>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        {section.fields.map((field, fieldIndex) => (
          <FieldEditor
            key={fieldIndex}
            sectionIndex={sectionIndex}
            fieldIndex={fieldIndex}
            field={field}
            updateField={updateField}
            removeField={removeField}
          />
        ))}
        <Tooltip title={getTranslation(translate, "process_model.schema.add_field")}>
          <IconButton
            onClick={() => addField(sectionIndex)}
            color="primary"
          >
            <Add />
          </IconButton>
        </Tooltip>
      </Box>
    </Paper>
  );
}